export default {
  // Add app specific club settings here
  DINING_EVENT_DEFAULT_MAX_DAYS_IN_ADVANCE: null,
  DINING_EVENT_DEFAULT_MAX_PARTY_SIZE: null,
  DINING_EVENT_DEFAULT_MIN_DAYS_IN_ADVANCE: null,
  DINING_MAX_DAYS_IN_ADV_STAFF: null,
  DINING_ONE_CLICK_TYPE: null,
  DINING_PAST_EVENT_MODIFY_DAYS: null,
  DINING_PAST_RES_MODIFY_DAYS: null,
  DINING_TABLE_ALPHA_SORT: null,
  DINING_USES_RESERVATIONS: null,
  DINING_USES_EVENTS: null,
  DINING_USES_WALKINS: null,
  DINING_DEFAULT_RESERVATION_NOTIFICATION_MODE: null,
  DINING_DEFAULT_EVENT_RESERVATION_NOTIFICATION_MODE: null,
  DINING_REPORT_KEEP_PAST_EVENTS_CURRENT: null,
  DINING_EVENT_FORCE_USE_TABLE_NUMBER: null,
  DINING_WARN_TABLE_NUMBER: null,
  DINING_WARN_TABLE_NUMBER_CLOSER_THAN: null,
  DINING_RESERVEE_SHOW_MEMNUM: null,
  DINING_RES_LIST_SHOW_GUEST_NAMES: false,
  DINING_RES_LIST_MAX_NAMES: 5,
  DINING_ENABLE_TABLE_AUTO_ASSIGN: false,
  DINING_ENABLE_FLOOR_PLAN: false,
  DINING_ENABLE_POS_CHARGE_INTEGRATION: false,
}
